import React from 'react'
import Box from 'transfix-ui/core/Box'
import {
  GetRequestForProposalsQueryParams as IRFPQueryParams,
  ShipperApplication,
  RequestForProposal,
} from 'apps/marketplace/apiTypes/requestForProposals'
import { Pagination, Spinner } from 'transfix-ui'
import { RequestForProposalsTable } from './RequestForProposalsTable'

const PER_PAGE = 20

interface IRequestForProposalPollingTableProps {
  loading: Boolean
  displayRfps: RequestForProposal[]
  rfpCount: number
  requestParams: IRFPQueryParams
  onPageChange: (newPageNumber: number) => void
  openDeleteConfirmationHandler: (id: number) => void
  openEditConfirmationHandler: (
    id: number,
    salesForceId: string,
    rfpType: string,
    shipperApplication: ShipperApplication
  ) => void
}
export const RequestForProposalPollingTable = ({
  displayRfps,
  loading,
  onPageChange,
  openDeleteConfirmationHandler,
  openEditConfirmationHandler,
  requestParams,
  rfpCount,
}: IRequestForProposalPollingTableProps) => {
  return (
    <>
      {loading && <Spinner position='absolute' />}
      {!loading && (
        <div>
          <Box mb={2}>
            <RequestForProposalsTable
              requestForProposals={displayRfps}
              openDeleteConfirmation={openDeleteConfirmationHandler}
              openEditConfirmation={openEditConfirmationHandler}
            />
          </Box>
          <Box textAlign='center'>
            <Pagination
              currentPage={(requestParams.pageCount || 0) + 1}
              numberOfPages={Math.ceil(rfpCount / PER_PAGE)}
              onPageChange={onPageChange}
            />
          </Box>
        </div>
      )}
    </>
  )
}
